import { render } from "./Temperature.vue?vue&type=template&id=4213cf7e"
import script from "./Temperature.vue?vue&type=script&lang=ts"
export * from "./Temperature.vue?vue&type=script&lang=ts"
script.render = render

export default script